module.exports = __webpack_public_path__ + "img/fang_gallery.bb0e7cab.svg";